import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { StoreSearchRequestBody, StoreSearchResponse } from "./types";

export class StoreSearchAPI extends BaseAPI<
  StoreSearchRequestBody,
  StoreSearchResponse
> {
  protected route = ApiRoutes.store.search;
  protected method = RequestMethod.POST;
}
